import React from 'react';
import { Box, Grid, Typography, Button, Paper } from '@mui/material';
import pdf from '../images/products/pdfpreview.jpeg';

const DownloadCard = ({ data }) => {
  return (
    <Paper
      elevation={3}
      sx={{
        borderRadius: 3,
        p: { xs: 2, sm: 3, md: 4 },
        my: { xs: 3, sm: 4 },
        mx: { xs: 1, sm: 2, md: 5 },
        height: { xs: 'auto', md: '300px' },
      }}
    >
      <Grid container spacing={3} alignItems="center">
        {/* Text Side */}
        <Grid item xs={12} md={7}>
          <Typography
            variant="h6"
            fontWeight="bold"
            gutterBottom
            sx={{ fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' } }}
          >
            Need More Info?
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}
          >
            Download our datasheet for further information on how to streamline deployment, enhance security, and reduce operational costs with a smarter communication solution.
          </Typography>

          <Button
            variant="contained"
            href={data.pdfFile}
            download
            sx={{
              mt: 2,
              backgroundColor: '#0055FF',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#003ECC',
              },
              borderRadius: '20px',
              textTransform: 'none',
              px: 3,
              py: 1,
              fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
            }}
          >
            Download Now
          </Button>
        </Grid>

        {/* Image Side */}
        <Grid item xs={12} md={5}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ height: { xs: '200px', md: '100%' }, width: '100%' }}
          >
            <Box
              component="img"
              src={pdf}
              alt="PDF Preview"
              sx={{
                maxHeight: { xs: '100%', md: '80%' },
                maxWidth: { xs: '80%', md: '70%' },
                objectFit: 'contain',
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default DownloadCard;
